{
  "LABEL_MGMT": {
    "HEADER": "Štítky",
    "HEADER_BTN_TXT": "Pridať štítok",
    "LOADING": "Načítavajú sa štítky",
    "DESCRIPTION": "Štítky vám pomáhajú kategorizovať a prioritizovať konverzácie a potenciálnych zákazníkov. Štítok môžete priradiť konverzácii alebo kontaktu pomocou bočného panela.",
    "LEARN_MORE": "Zistiť viac o štítkoch",
    "SEARCH_404": "Neexistujú žiadne položky, ktoré by zodpovedali tejto požiadavke",
    "LIST": {
      "404": "V tomto účte nie sú dostupné žiadne štítky.",
      "TITLE": "Spravovať štítky",
      "DESC": "Štítky vám umožňujú zoskupovať konverzácie.",
      "TABLE_HEADER": {
        "NAME": "Meno",
        "DESCRIPTION": "Popis",
        "COLOR": "Farba"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Názov štítku",
        "PLACEHOLDER": "Názov štítku",
        "REQUIRED_ERROR": "Názov štítku je povinný",
        "MINIMUM_LENGTH_ERROR": "Minimálna dĺžka je 2 znaky",
        "VALID_ERROR": "Povolené sú iba písmená, čísla, pomlčka a podčiarkovník"
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "Popis štítku"
      },
      "COLOR": {
        "LABEL": "Farba"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Zobraziť štítok v bočnom paneli"
      },
      "EDIT": "Upraviť",
      "CREATE": "Vytvoriť",
      "DELETE": "Vymazať",
      "CANCEL": "Zrušiť"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Pridať štítok ku konverzácii",
        "MULTIPLE_SUGGESTION": "Vybrať tento štítok",
        "DESELECT": "Zrušiť výber štítku",
        "DISMISS": "Zamietnuť návrh"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Zamietnuť",
      "ADD_SELECTED_LABELS": "Pridať vybrané štítky",
      "ADD_SELECTED_LABEL": "Pridať vybraný štítok",
      "ADD_ALL_LABELS": "Pridať všetky štítky",
      "SUGGESTED_LABELS": "Navrhované štítky"
    },
    "ADD": {
      "TITLE": "Pridať štítok",
      "DESC": "Štítky vám umožňujú zoskupovať konverzácie.",
      "API": {
        "SUCCESS_MESSAGE": "Štítok bol úspešne pridaný",
        "ERROR_MESSAGE": "Nastala chyba, skúste to prosím znova"
      }
    },
    "EDIT": {
      "TITLE": "Upraviť štítok",
      "API": {
        "SUCCESS_MESSAGE": "Štítok bol úspešne aktualizovaný",
        "ERROR_MESSAGE": "Nastala chyba, skúste to prosím znova"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Štítok bol úspešne odstránený",
        "ERROR_MESSAGE": "Nastala chyba, skúste to prosím znova",
        "IN_USE_ERROR": "Tento štítok nie je možné odstrániť, pretože sa používa v: {usages}. Najprv ho z týchto záznamov odstráňte.",
        "IN_USE_FILTERS": "filtre: {names}",
        "IN_USE_AUTOMATIONS": "automatizačné pravidlá: {names}",
        "IN_USE_MACROS": "makrá: {names}"
      },
      "CONFIRM": {
        "TITLE": "Potvrdiť vymazanie",
        "MESSAGE": "Určite chcete vymazať ",
        "YES": "Áno, vymazať ",
        "NO": "Nie, ponechať "
      }
    }
  }
}
